import { z } from 'zod';

//TODO: Replace these types with the ones from management-app-client when pnpm works with the chat app.

export type AgentFilterItem = {
  id: number;
  identifier: string;
  label: string;
  type: FilterTypeEnum;
  operators: string[];
  data: FilterData;
};


export enum FilterTypeEnum {
  Dropdown = 1,
  DateRange = 2,
  Autocomplete = 3,
}


export type FilterData<T extends FilterTypeEnum = FilterTypeEnum> = z.infer<typeof FilterDataSchemaMap[T]>;

// Basic Zod schemas for validation
export const FilterItemSchema = z.object({
  key: z.string(),
  value: z.string(),
});

export const DropdownFilterDataSchema = z.object({
  items: z.array(FilterItemSchema),
});

export const AutocompleteFilterDataSchema = z.object({
  endpoint: z.url(),
});

export const FilterDataSchema = z.union([DropdownFilterDataSchema, AutocompleteFilterDataSchema]);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const FilterDataSchemaMap = {
  [FilterTypeEnum.Dropdown]: DropdownFilterDataSchema,
  [FilterTypeEnum.DateRange]: DropdownFilterDataSchema,
  [FilterTypeEnum.Autocomplete]: AutocompleteFilterDataSchema,
};